import XAxis from './XAxis';
import Axis from '../Axis';
var ChartXAxis = XAxis;
ChartXAxis.Title = Axis.Title;
export default ChartXAxis;